import AuthenticationWrapper from 'modules/authentication/AuthenticationWrapper';
import LoginPage from 'modules/authentication/LoginPage';
import SignupPage from 'modules/authentication/SignupPage';

import ForgotPasswordPage from 'modules/authentication/ForgotPasswordPage';
import ResetPasswordPage from 'modules/authentication/ResetPasswordPage';
import SecurityVerificationPage from 'modules/authentication/SecurityVerificationPage';
import { CheckDashingLogOn } from './RouteGuard';

const AuthenticationRoutes = (isUserLoggedIn: boolean, id: string): any => ({
    path: '/',
    element: CheckDashingLogOn(isUserLoggedIn, id, <AuthenticationWrapper />),
    children: [
        {
            path: 'login',
            element: <LoginPage />,
        },
        {
            path: 'sign-up',
            element: <SignupPage />,
        },
        {
            path: 'forgot-password',
            element: <ForgotPasswordPage />,
        },
        {
            path: 'reset-password',
            element: <ResetPasswordPage />,
        },
        {
            path: 'security-verification',
            element: <SecurityVerificationPage />,
        },

        // {
        //     path: '',
        //     element: <Navigate to="/login" />,
        // },
    ],
});

export default AuthenticationRoutes;
